import { createFileRoute } from '@tanstack/react-router';
import { CatalogoPageAuthEntrar } from '@/features/catalogo/page/auth/CatalogoPageAuthEntrar';

export const Route = createFileRoute('/p/catalogo/$slug/auth/entrar')({
    component: CatalogoPageAuthEntrar,
});
